import {useState, useEffect} from 'react';
import quranBackdrop from '../../assets/images/quranBackdrop.svg';
import './HolyQuranStyle.scss';
// import playIcon from '../../assets/icons/play.svg';
import {useNavigate} from "react-router-dom";
import {SurahQuranData} from './SurahQuranData';
import Col from 'react-bootstrap/Col';
import {Fab} from "@mui/material";
import {Add, ArrowBack, ArrowForward} from "@mui/icons-material";
import BackComponent from '../BackComponent/BackComponent.tsx';

let QuranInfo = SurahQuranData;

export default function Quran() {
    const [quranValue, setQuranValue] = useState([]);
    const nav = useNavigate();
    useEffect(() => {
        setData()

    }, [setQuranValue])

    const setData = () => {
        setQuranValue(QuranInfo)
    }

    const search = (serachValue) => {
        if (serachValue == null) {
            setQuranValue(QuranInfo)
        } else {
            var data = []
            QuranInfo.forEach(element => {
                if (element.nameOfSurah.indexOf(serachValue) > -1) {
                    data.push(element)
                } else {

                }
            });
            setQuranValue(data)
        }

    }
    const goTOSurePage = (id) => {
        nav(`/Quran/${id}`)
    }

    return (
        <div className='Holy-QuranPage'>
            <div className='body-secondPage'>
                <div className='col-12 col-md-7 m-auto mt-md-2 mt-2 mb-md-6'>
                    <BackComponent/>
                    <div className='nameOfSure col-11 col-md-9 mt-md-5 mt-5 m-auto'>
                        <div>
                            <img src={quranBackdrop} alt=""/>
                        </div>
                        <div className='searchBox col-9 col-md-6'>
                            <div><span>سوره مورد نظر خود را وارد نمایید </span></div>
                            <div className='searchInput-box'><input type="text" className='searchText'
                                                                    onChange={event => {
                                                                        search(event.target.value)
                                                                    }}/></div>
                        </div>
                    </div>
                </div>
                <div className='quran-container col-11 col-md-9'>
                    <div className='surah'>
                        <div className='container-holypage'>

                            {quranValue.length === 0 &&
                                <Col xs={12} md={12}>
                                    <div className='notFind-Surah'>
                                        <span>هیچ سوره ای پیدا نشد.</span>
                                    </div>
                                </Col>
                            }

                            {
                                quranValue.map((surah) =>
                                    <div onClick={() => {
                                        goTOSurePage(`${surah.countOfSurah}`)
                                    }} key={surah.countOfSurah} className='surah-container'>
                                        <div className='surah-boxStyle col-10 col-md-11'>
                                            <div className='surah-number col-2'>

                                                <span className='p-1 p-md-0'>{surah.countOfSurah}</span>
                                            </div>
                                            <span className='surah-name col-11'
                                                  id={surah.countOfSurah + 1}>{surah.nameOfSurah}</span>
                                        </div>

                                        {/* <div className='playIconQuran-style col-1 col-md-1'><img className='col-5' src={playIcon} alt="" /></div> */}
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
            </div>
            <div>

            </div>
        </div>
    )
}
